// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"2c4fb8be","596":"898ab196"}[chunkId] + ".css";
};